import { useCallback, useEffect, useState } from 'react';
import { useUser } from '@/hooks/useUser';

type StocksView = 'tile' | 'table';

export const useStocksView = () => {
  const [stocksView, setStocksView] = useState<StocksView>();
  const {
    data: user,
    mutate: mutateUser,
    isFetched: isUserFetched,
  } = useUser();

  useEffect(() => {
    if (isUserFetched && typeof stocksView === 'undefined' && user.loggedIn) {
      setStocksView(user.defaultStocksView);
    }
  }, [isUserFetched, user, stocksView]);

  const handleViewSelect = useCallback(
    (value: StocksView) => {
      setStocksView(value);
      if (user.loggedIn) {
        mutateUser({ settings: { stocks_view: value } });
      }
    },
    [mutateUser, user]
  );

  return { stocksView, handleViewSelect };
};
